(function () {
  var STORAGE_KEY = 'rg_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function updateHeartStates() {
    var list = getWishlist();
    var ids = list.map(function (item) { return item.id; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', ids.indexOf(id) !== -1);
    });
  }

  function renderDrawer() {
    var list = getWishlist();
    var container = document.querySelector('[data-wishlist-list]');
    var emptyState = document.querySelector('[data-wishlist-empty]');
    if (!container) return;

    if (list.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;

    container.innerHTML = list.map(function (item) {
      return (
        '<li class="rg-wishlist-drawer__item">' +
          '<a href="' + item.url + '" class="rg-wishlist-drawer__item-link" data-drawer-close>' +
            '<span class="rg-wishlist-drawer__item-thumb">' +
              (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '') +
            '</span>' +
            '<span class="rg-wishlist-drawer__item-info">' +
              '<span class="rg-wishlist-drawer__item-title">' + item.title + '</span>' +
              '<span class="rg-wishlist-drawer__item-price">' + item.price + '</span>' +
            '</span>' +
          '</a>' +
          '<button type="button" class="rg-wishlist-drawer__item-remove" aria-label="Remove from wishlist" data-wishlist-remove="' + item.id + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
        '</li>'
      );
    }).join('');
  }

  function toggle(id, data) {
    var list = getWishlist();
    var index = list.findIndex(function (item) { return item.id === id; });
    if (index === -1) {
      list.push(data);
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    updateCountBadges();
    updateHeartStates();
    renderDrawer();
  }

  function remove(id) {
    var list = getWishlist().filter(function (item) { return item.id !== id; });
    saveWishlist(list);
    updateCountBadges();
    updateHeartStates();
    renderDrawer();
  }

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      toggle(toggleBtn.getAttribute('data-product-id'), {
        id: toggleBtn.getAttribute('data-product-id'),
        title: toggleBtn.getAttribute('data-product-title') || '',
        image: toggleBtn.getAttribute('data-product-image') || '',
        price: toggleBtn.getAttribute('data-product-price') || '',
        url: toggleBtn.getAttribute('data-product-url') || '#'
      });
      return;
    }

    var removeBtn = event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      remove(removeBtn.getAttribute('data-wishlist-remove'));
    }
  });

  function init() {
    updateCountBadges();
    updateHeartStates();
    renderDrawer();
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();
